module.exports = __webpack_public_path__ + "img/SummaryBannerMobile.6efdce4f.png";